import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import BaseViewModel from "./../../factories/base-view-model";
import BaoDialog from "./../../factories/bao-dialog";
function RegisteredUser(tabPage) {
    var self = this;
    self.Bao = Bao;
    BaseViewModel.call(this, tabPage);
    self.Sorting = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(25);
    self.SelectedUserRow = ko.observable();
    self.UserCollection = ko.observableArray([]);
    self.Sorting.subscribe(function () {
        self.RefreshAktiveUser();
    });
    self.PageIndex.subscribe(function () {
        self.RefreshAktiveUser();
    });
    self.SelectUserRow = function (item) {
        this.SelectedUserRow(item);
        return true;
    };
    self.SelectedUserRow.subscribe(function () {
        BaoMenu.permissionEnable({
            ActionKey: "RegisteredUserRemove",
            Enabled: false,
            Context: tabPage.Context()
        });
        if (self.SelectedUserRow() != null) {
            if (self.SelectedUserRow().IsUserActive == true) {
                BaoMenu.permissionEnable({
                    ActionKey: "RegisteredUserRemove",
                    Enabled: true,
                    Context: tabPage.Context()
                });
            }
        }
    });
    BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab()) {
            switch (value.ActionKey()) {
                case "RegisteredUserRemove":
                    self.RemoveAktiveUser();
                    break;
                case "RegisteredUserRefresh":
                    self.RefreshAktiveUser();
                    break;
            }
        }
    });
    self.RemoveAktiveUser = function () {
        var questionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgKillSessionsOfUser"), "yesno");
        questionDialog.DialogResult.subscribe(function (dialogResult) {
            if (dialogResult === true) {
                return Bao.post("Checkware/RegisteredUser/RemoveAktiveUser", JSON.stringify({
                    userId: self.SelectedUserRow().UserId
                }), function () {
                    self.RefreshAktiveUser();
                });
            }
        });
    };
    self.RefreshAktiveUser = function () {
        tabPage.IsLoading(true);
        self.GetAllUser();
        tabPage.IsLoading(false);
    };
    self.GetAllUser = function () {
        return Bao.post("Checkware/RegisteredUser/GetUser", JSON.stringify({
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            if (searchResult.Models != null) {
                self.SelectedUserRow();
                self.UserCollection([]);
                self.UserCollection(searchResult.Models);
            }
        });
    };
    self.loaded = function () {
        BaoMenu.permissionEnable({
            ActionKey: "RegisteredUserRemove",
            Enabled: false,
            Context: tabPage.Context()
        });
        self.GetAllUser();
    };
}
export default RegisteredUser;